let directive = function() {
	return function(scope, element, attrs) {
		element.bind('keydown', function(event) {
			if(event.which === 13) {
				scope.$apply(function() {
					scope.$eval(attrs.enterblocker)
				});
				event.preventDefault();
			}
		});
	}
};

export default directive;


// WEBPACK FOOTER //
// ./app/shared/directives/enterblocker.directive.js